module.exports = __webpack_public_path__ + "static/img/photo13.c14b2a3a.jpg";